import React, { Component } from "react";
import { Table, Button, Modal, Col, Row, message, Tooltip, Card, InputNumber } from "antd";
import InputForm from "../components/InputForm";
import "../components/Form.css";
import "./Pages.css";
import axios from "axios";
import VendaBalcaoForm from '../components/VendaBalcaoForm';
import VendaBalcaoCondicioanisForm from '../components/VendaBalcaoCondicioanisForm';
import CondicionalPrintModal from "../relatorios/CondicionalPrintModal";
import PedidoPrintA4Modal from "../relatorios/PedidoPrintA4Modal";
import PedidoPrintCupomModal from "../relatorios/PedidoPrintCupomModal";
import ModalPadraoForm from '../components/ModalPadraoForm';
import SpinnerForm from '../components/SpinnerForm';
import moment from "moment-timezone";
import numeral from "numeral";
import Colors from '../utils/Colors';
import ProdutoFrame from '../components/ProdutoFrame';
import { getUsuario } from "../utils/LoginManager";
import CaixaLivre from '../tutoriais/LancCaixaLivre';

const { Column } = Table;
const ButtonGroup = Button.Group;

export default class extends Component {
  state = {
    registro: {
      ven_idf: 0,
      ven_numero: '',
      ven_dt_venda: moment().format('DD/MM/YYYY'),
      ven_obs: '',
      ven_qtde_itens: 0,
      ven_vlr_itens: 0,
      ven_vlr_acres: 0,
      ven_vlr_desc: 0,
      ven_vlr_total: 0,
      ven_pessoa: { key: '0' },
      ven_usuario: { key: '0' },
      ven_tipo_doc: { key: '0' },
      ven_cond_pagto: { key: '0' },
      ven_tipo_venda: { key: 'V' },
    },

    carregandoForm: false,
    editando: false,
    visualizando: false,
    caixaFechado: false,

    idfVenda: 0,
    formPrintCondVisivel: false,
    formPrintA4Visivel: false,
    formPrintCupomVisivel: false,

    modalReceberVisible: false,
    modalCondicionaisVisible: false,
    modalListaVisible: false,
    telaModal: '',

    mi_seq: 0,
    mi_item: { key: '0' },
    prod_codigo: '',
    prod_descricao: '',
    prod_ncm: '',
    prod_cod_barras: '',
    med_descricao: '',
    mi_qtde: 1,
    mi_vlr_unit: 0,
    mi_vlr_venda: 0,
    mi_vlr_venda_min: 0,
    mi_perc_desc: 0,
    mi_vlr_desc: 0,
    mi_vlr_acres: 0,
    mi_vlr_total: 0,

    listaProdutos: [],
    listaParcelas: [],
    vlrTotalParc: 0,
    vlrDifParc: 0,
    formParcVisible: false,

    registroParcela: {
      tparc_parcela: 0,
      tparc_data_parcela: '',
      tparc_tipo_doc: { key: '0' },
      tparc_conta_corrente: { key: '0' },
      tparc_valor: 0,
      tparc_situacao: { key: 'A', label: 'ABERTO', },
      tparc_obs: '',
      td_descricao: '',
      cc_descricao: '',
      situacao_parcela: '',
      pgto_vlr_desconto: 0,
      pgto_vlr_acrescimo: 0,
      pgto_vlr_pago: 0,
      pgto_vlr_restante: 0,
      pgto_data: '',
      pgto_cta_corrente: '',
    }
  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
  }

  componentDidUpdate(antProps, antState) {

  }


  onSalvarClick = (registro) => {
    this.setState({ salvando: true });

    let request;
    if (registro.ven_tipo_venda === 'V') {
      if (registro.ven_idf) {
        request = axios.put(`/vendas/update/${registro.ven_idf}`, registro);
      } else {
        request = axios.post(`/vendas/store`, registro)
      }
    } else {
      if (registro.venc_idf) {
        request = axios.put(`/condicional/update/${registro.venc_idf}`, registro);
      } else {
        request = axios.post(`/condicional/store`, registro)
      }
    }

    request
      .then(response => {
        this.onNovoClick();
        this.setState({
          formVisivel: false,
          salvando: false,
        })

        if (registro.registroNfe) {
          Modal.success({
            title: 'Nota Fiscal',
            okText: 'OK',
            width: '25%',
            content: (
              <div>
                <div>{'Nota TRANSMITIDA com Sucesso'}</div>
                <div>NFe: {response.data.nfe}</div>
                <div>{response.data.chave ? 'Chave: ' + response.data.chave : ''}</div>
              </div>
            ),
          })
          const reg = {
            nf_idf: response.data.idfNF,
            nf_emitente: registro.registroNfe.nf_emitente,
            nf_chave: response.data.chave,
          }
          this.onImprimirNFeClick(reg);
        } else {
          if (registro.ven_tipo_venda === 'V') {
            if (this.state.usuario.par_impr_venda_balcao === 'COM') {
              this.onImprimirA4Click(response.data.idf);
            } else if (this.state.usuario.par_impr_venda_balcao === 'CUP') {
              this.onImprimirCupomClick(response.data.idf);
            }
          } else {
            this.onImprimirCondicionalClick(response.data.idf);
          }
        }
        message.success('Venda gravada com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.onNovoClick();
        this.setState({
          formVisivel: false,
          salvando: false
        })
        if ((error.response) && (error.response.status === 401)) {
          if (error.response.data.status) {
            if ((error.response.data.status === 5001) || (error.response.data.status === 5002)) {
              Modal.error({
                title: 'Nota Fiscal',
                okText: 'OK',
                width: '25%',
                content: (
                  <div>
                    <div>Problema com os dados da Nota Fiscal</div>
                    <div>NFe: {error.response.data.nfe}</div>
                    <div>{error.response.data.chave ? 'Chave: ' + error.response.data.chave : ''}</div>
                    <div>{error.response.data.status ? 'ERRO: ' + error.response.data.status + (error.response.data.erros ? ' - ' + error.response.data.erros : '') : ''}</div>
                  </div>
                )
              })
            } else {
              Modal.error({
                title: 'Emissão Nota Fiscal',
                okText: 'OK',
                width: '25%',
                content: (
                  <div>
                    <div>Erro no Retorno da SEFAZ</div>
                    <div>NFe: {error.response.data.nfe}</div>
                    <div>{error.response.data.chave ? 'Chave: ' + error.response.data.chave : ''}</div>
                    <div>Mensagem: {error.response.data.mensagem}</div>
                    <div>{error.response.data.status ? 'ERRO: ' + error.response.data.status + (error.response.data.erros ? ' - ' + error.response.data.erros : '') : ''}</div>
                  </div>
                )
              })
            }
          } else {
            Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
          }
        } else {
          Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
        }
      })
  }

  onImprimirCondicionalClick = (ven_idf) => {
    this.setState({
      idfVenda: ven_idf,
      formPrintCondVisivel: true,
    });
  };

  onImprimirA4Click = (ven_idf) => {
    this.setState({
      idfVenda: ven_idf,
      formPrintA4Visivel: true,
    });
  };

  onImprimirCupomClick = (ven_idf) => {
    this.setState({
      idfVenda: ven_idf,
      formPrintCupomVisivel: true,
    });
  };

  onCancelarPrintClick = () => {
    this.setState({
      idfVenda: 0,
      formPrintCondVisivel: false,
      formPrintA4Visivel: false,
      formPrintCupomVisivel: false
    })
  }

  onImprimirNFeClick = (registro) => {
    this.setState({ carregando: true });
    axios
      .get('/notas_fiscais/imprimir', {
        params: {
          emitente: registro.nf_emitente,
          idf: registro.nf_idf,
          chave: registro.nf_chave,
        }
      })
      .then(response => {
        const { data } = response;
        if (data.sucesso) {
          const file_url = 'https://api.fastgestor.plenasistemas.inf.br/image/emp' + this.state.usuario.emp_codigo + '/pdf/' + data.url;
          window.open(file_url, '_blank')
        } else {
          Modal.error({ title: 'Falha - Atenção!', width: '25%', content: 'Não foi possível IMPRIMIR. ' + data.mensagem, okText: 'OK', })
        }
        this.setState({
          carregando: false,
        })
      })
      .catch(error => {
        // console.log(error.response);
        Modal.error({ title: 'Erro ao Imprimir', width: '25%', content: error.response.data.mensagem, okText: 'OK', })
        this.setState({
          carregando: false,
        })
      })
  };


  calculoTotalPedido = (listaProdutos) => {
    // console.log('calculoTotalPedido: ', listaProdutos);

    const { registro } = this.state;
    let qtdeItens = 0;
    let vlrItens = 0;
    let vlrDesc = 0;
    let vlrAcres = 0;
    let vlrTotal = 0;

    for (var x in listaProdutos) {
      qtdeItens = qtdeItens + parseFloat(listaProdutos[x].mi_qtde);
      vlrItens = vlrItens + (parseFloat(listaProdutos[x].mi_qtde) * parseFloat(listaProdutos[x].mi_vlr_unit));
      vlrDesc = vlrDesc + parseFloat(listaProdutos[x].mi_vlr_desc);
      vlrAcres = vlrAcres + parseFloat(listaProdutos[x].mi_vlr_acres);
      vlrTotal = vlrTotal + parseFloat(listaProdutos[x].mi_vlr_total);
    };

    qtdeItens = parseFloat(qtdeItens);
    vlrItens = parseFloat(vlrItens.toFixed(2));
    vlrDesc = parseFloat(vlrDesc.toFixed(2));
    vlrAcres = parseFloat(vlrAcres.toFixed(2));
    vlrTotal = parseFloat(vlrTotal.toFixed(2));

    // console.log('calculoTotalPedido: ', qtdeItens);
    // console.log('calculoTotalPedido: ', vlrTotal);
    // console.log('calculoTotalPedido: ', listaProdutos);

    registro.ven_qtde_itens = qtdeItens;
    registro.ven_vlr_itens = vlrItens;
    registro.ven_vlr_desc = vlrDesc;
    registro.ven_vlr_acres = vlrAcres;
    registro.ven_vlr_total = vlrTotal;

    this.setState({
      registro
    },
      this.forceUpdate()
    );
  }


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };





  // ----------------------------------------------------------------
  // PRODUTOS
  // ----------------------------------------------------------------


  onChangeProduto = event => {
    // console.log('onChangeProduto: ', event);
    const { registro } = this.state;

    this.state.mi_item = event.mi_item;
    this.state.mi_vlr_unit = parseFloat(event.mi_item.vlrVenda);
    this.state.mi_perc_desc = 0;
    this.state.mi_vlr_desc = 0;
    this.setState(event);

    const { mi_qtde, mi_perc_desc, mi_vlr_desc } = this.state;
    this.calculoItem(mi_qtde, parseFloat(event.mi_item.vlrVenda), mi_perc_desc, mi_vlr_desc);
  }

  onInputChangeQtde = event => {
    this.setState({ mi_qtde: event });
    const { mi_vlr_unit, mi_perc_desc, mi_vlr_desc } = this.state;
    this.calculoItem(event, mi_vlr_unit, mi_perc_desc, mi_vlr_desc);
  }

  onInputChangeVlrUnit = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
    const { mi_qtde, mi_perc_desc, mi_vlr_desc } = this.state;
    this.calculoItem(mi_qtde, value, mi_perc_desc, mi_vlr_desc);
  }

  onInputChangePercDesc = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value,
      mi_vlr_desc: 0
    });
    const { mi_qtde, mi_vlr_unit } = this.state;
    this.calculoItem(mi_qtde, mi_vlr_unit, value, 0);
  }

  onInputChangeVlrDesc = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value,
      mi_perc_desc: 0
    });
    const { mi_qtde, mi_vlr_unit } = this.state;
    this.calculoItem(mi_qtde, mi_vlr_unit, 0, value);
  }

  calculoItem = (mi_qtde, mi_vlr_unit, mi_perc_desc, mi_vlr_desc) => {
    const vlrUnit = mi_vlr_unit ? parseFloat(mi_vlr_unit) : 0;
    const qtde = mi_qtde ? parseFloat(mi_qtde) : 0;
    let percDesc = percDesc ? parseFloat(mi_perc_desc) : 0;
    let vlrDesc = mi_vlr_desc ? parseFloat(mi_vlr_desc) : 0;

    if (vlrDesc === 0) {
      percDesc = mi_perc_desc ? (parseFloat(mi_perc_desc) / 100) : 0;
      vlrDesc = parseFloat((parseFloat(mi_qtde) * parseFloat(vlrUnit)) * percDesc);
    }

    let vlrTotal = parseFloat(parseFloat(vlrUnit) * parseFloat(qtde)) - parseFloat(vlrDesc);

    this.setState({
      mi_vlr_total: vlrTotal,
      mi_vlr_desc: vlrDesc,
    });
  }




  onFormIncluirProduto = (event) => {
    const { ven_idf, mi_item, mi_qtde,
      mi_vlr_unit, mi_vlr_venda, mi_vlr_venda_min, mi_perc_desc, mi_vlr_acres, mi_vlr_desc, mi_vlr_total } = this.state;

    if ((!mi_item) || (mi_item.key === '0') || (mi_item.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Produto' });
      return;
    }
    if (!mi_qtde) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Quantidade' });
      return;
    }
    const vlrTotalAux = parseFloat(mi_vlr_total);
    if (!vlrTotalAux) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Valor do Produto' });
      return;
    }

    let iIndItem = -1;
    for (var x in this.state.listaProdutos) {
      if (
        (String(this.state.listaProdutos[x].prod_idf) === String(this.state.mi_item.pest_item)) &&
        (String(this.state.listaProdutos[x].mi_item_tamanho) === String(this.state.mi_item.pest_tamanho)) &&
        (String(this.state.listaProdutos[x].mi_item_cor) === String(this.state.mi_item.pest_cor))
      ) {
        iIndItem = x;
      }
    }

    if (iIndItem >= 0) {

      this.state.listaProdutos[iIndItem].mi_qtde = parseFloat(mi_qtde);
      this.state.listaProdutos[iIndItem].mi_vlr_unit = parseFloat(mi_vlr_unit);
      this.state.listaProdutos[iIndItem].mi_perc_desc = parseFloat(mi_perc_desc === '' ? '0' : mi_perc_desc);
      this.state.listaProdutos[iIndItem].mi_vlr_desc = parseFloat(mi_vlr_desc === '' ? '0' : mi_vlr_desc);
      this.state.listaProdutos[iIndItem].mi_vlr_acres = parseFloat(mi_vlr_acres === '' ? '0' : mi_vlr_acres);
      this.state.listaProdutos[iIndItem].mi_vlr_total = parseFloat(mi_vlr_total);

    } else {

      this.state.listaProdutos.push({
        ven_idf: 0,
        venc_idf: 0,
        mi_idf_condicional: 0,
        mi_item: this.state.mi_item.pest_item,
        mi_seq: 0,
        prod_idf: this.state.mi_item.pest_item,
        pest_qtde: this.state.mi_item.pest_qtde,
        prod_grade: this.state.mi_item.prod_grade,
        mi_item_tamanho: this.state.mi_item.pest_tamanho,
        mi_item_cor: this.state.mi_item.pest_cor,
        ptam_descricao: this.state.mi_item.ptam_descricao,
        pcor_descricao: this.state.mi_item.pcor_descricao,
        prod_codigo: this.state.mi_item.cod,
        prod_descricao: this.state.mi_item.descr,
        prod_ncm: this.state.mi_item.prod_ncm,
        prod_cod_barras: this.state.mi_item.prod_cod_barras,
        med_descricao: this.state.mi_item.med_descricao,
        mi_qtde: parseFloat(mi_qtde),
        mi_vlr_unit: parseFloat(mi_vlr_unit),
        mi_vlr_venda: mi_vlr_venda,
        mi_vlr_venda_min: mi_vlr_venda_min,
        mi_perc_desc: parseFloat(mi_perc_desc === '' ? '0' : mi_perc_desc),
        mi_vlr_desc: parseFloat(mi_vlr_desc === '' ? '0' : mi_vlr_desc),
        mi_vlr_acres: parseFloat(mi_vlr_acres === '' ? '0' : mi_vlr_acres),
        mi_vlr_total: parseFloat(mi_vlr_total),
      });
    }

    this.setState({
      mi_item: { key: '0' },
      prod_codigo: '',
      prod_descricao: '',
      prod_ncm: '',
      prod_cod_barras: '',
      med_descricao: '',
      mi_qtde: 1,
      mi_vlr_unit: 0,
      mi_vlr_venda: 0,
      mi_vlr_venda_min: 0,
      mi_perc_desc: 0,
      mi_vlr_desc: 0,
      mi_vlr_acres: 0,
      mi_vlr_total: 0,
    },
      this.calculoTotalPedido(this.state.listaProdutos)
    );
  }

  onEditarProdutosClick = (reg) => {
    this.setState({
      mi_item: {
        key: String(reg.mi_item) + '_' + String(reg.mi_item_tamanho) + '_' + String(reg.mi_item_cor),
        label: (reg.prod_grade ? (reg.prod_descricao + ' - ' + reg.ptam_descricao + ' - ' + reg.pcor_descricao) : reg.prod_descricao) + ' [' + reg.prod_codigo + ']' + (reg.prod_cod_barras !== '' ? ' [' + reg.prod_cod_barras + ']' : ''),
        prod_grade: reg.prod_grade,
        prod_cod_barras: reg.prod_cod_barras,
        pest_item: reg.mi_item,
        pest_tamanho: reg.mi_item_tamanho,
        pest_cor: reg.mi_item_cor,
        ptam_descricao: reg.ptam_descricao,
        pcor_descricao: reg.pcor_descricao,
      },
      prod_codigo: reg.prod_codigo,
      prod_descricao: reg.prod_descricao,
      prod_ncm: reg.prod_ncm,
      prod_cod_barras: reg.prod_cod_barras,
      med_descricao: reg.med_descricao,
      mi_qtde: reg.mi_qtde,
      mi_vlr_unit: reg.mi_vlr_unit,
      mi_vlr_venda: reg.mi_vlr_venda ? reg.mi_vlr_venda : 0,
      mi_vlr_venda_min: reg.mi_vlr_venda_min ? reg.mi_vlr_venda_min : 0,
      mi_perc_desc: reg.mi_perc_desc,
      mi_vlr_desc: reg.mi_vlr_desc,
      mi_vlr_total: reg.mi_vlr_total,
    });

  }

  onExcluirProdutosClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este produto?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaProdutos = [...this.state.listaProdutos];
        const index = listaProdutos.findIndex(registro => registro.prod_idf + '_' + registro.mi_item_tamanho + '_' + registro.mi_item_cor === reg.prod_idf + '_' + reg.mi_item_tamanho + '_' + reg.mi_item_cor);
        listaProdutos.splice(index, 1);
        this.setState({
          listaProdutos,
          mi_item: { key: '0' },
          prod_codigo: '',
          prod_descricao: '',
          prod_ncm: '',
          prod_cod_barras: '',
          med_descricao: '',
          mi_qtde: 1,
          mi_vlr_unit: 0,
          mi_vlr_venda: 0,
          mi_vlr_venda_min: 0,
          mi_perc_desc: 0,
          mi_vlr_desc: 0,
          mi_vlr_acres: 0,
          mi_vlr_total: 0,
        },
          this.calculoTotalPedido(listaProdutos)
        );
      }
    })
  }

  renderValor = (ven_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
    );
  };

  renderDescrProduto = (prod_descricao, registro) => {
    return (
      <span> {!registro.prod_grade ? prod_descricao : registro.prod_descricao + ' - ' + registro.ptam_descricao + ' - ' + registro.pcor_descricao} </span>
    );
  };


  renderAcoesProdutos = (registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Editar">
          <Button type="primary" onClick={() => this.onEditarProdutosClick(registro)} icon="edit" />
        </Tooltip>
        <Tooltip title="Excluir">
          <Button type="danger" onClick={() => this.onExcluirProdutosClick(registro)} icon="delete" />
        </Tooltip>
      </ButtonGroup>
    );
  };

  onOKCondicionaisClick = (listaProdutos, ven_pessoa, pes_nome, qtdeItens, vlrItens, vlrDesc, vlrAcres, vlrTotal) => {

    this.setState({
      registro: {
        ven_idf: 0,
        ven_numero: '',
        ven_dt_venda: moment().format('DD/MM/YYYY'),
        ven_obs: '',
        ven_qtde_itens: qtdeItens,
        ven_vlr_itens: vlrItens,
        ven_vlr_acres: vlrAcres,
        ven_vlr_desc: vlrDesc,
        ven_vlr_total: vlrTotal,
        ven_pessoa: {
          key: ven_pessoa ? ven_pessoa : '0',
          label: pes_nome ? pes_nome : '',
        },
        ven_usuario: { key: '0' },
        ven_tipo_doc: { key: '0' },
        ven_cond_pagto: { key: '0' },
        ven_tipo_venda: { key: 'V' },
      },
      listaProdutos,
      modalReceberVisible: false,
      modalListaVisible: false,
      modalCondicionaisVisible: false,
      telaModal: '',
    });
  }


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  onFecharModalLista = () => {
    this.setState({
      modalReceberVisible: false,
      modalListaVisible: false,
      modalCondicionaisVisible: false,
      telaModal: '',
    });
  }

  onNovoClick = () => {
    this.setState({
      registro: {
        ven_idf: 0,
        ven_numero: '',
        ven_dt_venda: moment().format('DD/MM/YYYY'),
        ven_obs: '',
        ven_qtde_itens: 0,
        ven_vlr_itens: 0,
        ven_vlr_acres: 0,
        ven_vlr_desc: 0,
        ven_vlr_total: 0,
        ven_pessoa: { key: '' },
        ven_usuario: { key: '' },
        ven_tipo_doc: { key: '' },
        ven_cond_pagto: { key: '' },
        ven_tipo_venda: { key: 'V' },
      },

      carregandoForm: false,
      editando: false,
      visualizando: false,
      caixaFechado: false,

      modalReceberVisible: false,
      modalListaVisible: false,
      telaModal: '',

      mi_seq: 0,
      mi_item: { key: '0' },
      prod_codigo: '',
      prod_descricao: '',
      prod_ncm: '',
      prod_cod_barras: '',
      med_descricao: '',
      mi_qtde: 1,
      mi_vlr_unit: 0,
      mi_vlr_venda: 0,
      mi_vlr_venda_min: 0,
      mi_perc_desc: 0,
      mi_vlr_desc: 0,
      mi_vlr_acres: 0,
      mi_vlr_total: 0,

      listaProdutos: [],
      listaParcelas: [],
      vlrTotalParc: 0,
      vlrDifParc: 0,
      formParcVisible: false,

      registroParcela: {
        tparc_parcela: 0,
        tparc_data_parcela: '',
        tparc_tipo_doc: { key: '0' },
        tparc_conta_corrente: { key: '0' },
        tparc_valor: 0,
        tparc_situacao: { key: 'A', label: 'ABERTO', },
        tparc_obs: '',
        td_descricao: '',
        cc_descricao: '',
        situacao_parcela: '',
        pgto_vlr_desconto: 0,
        pgto_vlr_acrescimo: 0,
        pgto_vlr_pago: 0,
        pgto_vlr_restante: 0,
        pgto_data: '',
        pgto_cta_corrente: '',
      }
    });
  }

  onReceberClick = () => {
    if ((this.state.listaProdutos) && (this.state.listaProdutos.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Inclua algum produto na venda', });
      return;
    }

    this.setState({
      modalReceberVisible: true,
      telaModal: 'receber',
      registroSelecionado: {
        dados: {
          ven_idf: 0,
          ven_numero: '',
          ven_dt_venda: moment().format('DD/MM/YYYY'),
          ven_obs: '',
          ven_qtde_itens: this.state.registro.ven_qtde_itens,
          ven_vlr_itens: this.state.registro.ven_vlr_itens,
          ven_vlr_acres: this.state.registro.ven_vlr_acres,
          ven_vlr_desc: this.state.registro.ven_vlr_desc,
          ven_vlr_total: this.state.registro.ven_vlr_total,
          ven_pessoa: {
            key: this.state.registro.ven_pessoa.key ? this.state.registro.ven_pessoa.key : '0',
            label: this.state.registro.ven_pessoa.label ? this.state.registro.ven_pessoa.label : '',
          },
          ven_usuario: {
            key: this.state.usuario.par_vendedor ? String(this.state.usuario.par_vendedor) : '0',
            label: this.state.usuario.par_vendedor ? this.state.usuario.usu_nome : '',
          },
          ven_tipo_doc: {
            key: String(this.state.usuario.par_doc_padrao),
            label: this.state.usuario.td_descricao,
          },
          ven_cond_pagto: {
            key: String(this.state.usuario.par_cond_pagto_padrao),
            label: this.state.usuario.td_descricao,
            qtdeParc: this.state.usuario.cp_qtde_parc,
            parcAVista: this.state.usuario.cp_parc_avista,
          },
          listaProdutos: this.state.listaProdutos,
          listaParcelas: [],
          visualizando: false,
          ven_tipo_venda: { key: 'V' },
        }
      },
      registroParcela: {
        tparc_parcela: 0,
        tparc_data_parcela: '',
        tparc_tipo_doc: { key: '0' },
        tparc_conta_corrente: { key: '0' },
        tparc_valor: 0,
        tparc_situacao: { key: 'A', label: 'ABERTO', },
        tparc_obs: '',
        td_descricao: '',
        cc_descricao: '',
        situacao_parcela: '',
        pgto_vlr_desconto: 0,
        pgto_vlr_acrescimo: 0,
        pgto_vlr_pago: 0,
        pgto_vlr_restante: 0,
        pgto_data: '',
        pgto_cta_corrente: '',
      }
    });
  }

  onPagtosClick = () => {
    if ((this.state.listaProdutos) && (this.state.listaProdutos.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Inclua algum produto na venda', });
      return;
    }

    this.setState({
      modalListaVisible: true,
      telaModal: 'pagtos',
    });
  }

  onClientesClick = () => {
    this.setState({
      modalListaVisible: true,
      telaModal: 'clientes',
    });
  }

  onFichaFinancClick = () => {
    this.setState({
      modalListaVisible: true,
      telaModal: 'fichaFinanc',
    });
  }

  onResumoCaixaClick = () => {
    this.setState({
      modalListaVisible: true,
      telaModal: 'resumoCaixa',
    });
  }

  onListaVendasClick = () => {
    if ((this.state.listaProdutos) && (this.state.listaProdutos.length > 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Caixa Ocupado', });
      return;
    }

    this.setState({
      modalListaVisible: true,
      telaModal: 'vendas',
    });
  }

  onListaCondicionaisClick = () => {
    if ((this.state.listaProdutos) && (this.state.listaProdutos.length > 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Caixa Ocupado', });
      return;
    }
    this.setState({
      modalCondicionaisVisible: true,
    });
  }


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------






  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { modalReceberVisible, modalListaVisible, modalCondicionaisVisible,
      telaModal, salvando, listaProdutos, registroSelecionado, formPrintA4Visivel, formPrintCupomVisivel, formPrintCondVisivel,
      mi_item, mi_qtde, mi_vlr_unit, mi_perc_desc, mi_vlr_desc, mi_vlr_total,
    } = this.state;

    const { ven_idf, ven_numero, ven_dt_venda, ven_pessoa, ven_obs, ven_cond_pagto, ven_tipo_doc,
      ven_qtde_itens, ven_vlr_total, ven_usuario } = this.state.registro;

    // console.log('VendaBalcaoPage.this.state: ', this.state);

    var windowHeight = window.innerHeight;

    return (
      <div style={{ padding: 10, backgroundColor: Colors.fundoPage, height: windowHeight - 75 }}>

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="tituloPage">{listaProdutos && listaProdutos.length === 0 ? 'CAIXA LIVRE' : 'CAIXA OCUPADO'}</span>
          <div>
            <Tooltip title="Video de Ajuda">
              <Button
                type="primary"
                onClick={() => window.open('https://www.youtube.com/watch?v=ewANs5sG1X8&list=PLpe5WZ31yjQa5k3LuG7hBzmY1J-mOW3zz&index=7', '_blank')}
                icon="youtube"
                className="botao-ajuda"
              ></Button>
            </Tooltip>
            <Tooltip title="Ajuda">
              <Button
                type="primary"
                onClick={() => this.setState({ modalOpen: true })}
                icon="question"
                className="botao-ajuda"
              ></Button>
            </Tooltip>
          </div>
        </div>
        <div className="divider-page" />

        <VendaBalcaoForm
          visivel={modalReceberVisible}
          registroSelecionado={registroSelecionado}
          carregando={salvando}
          onFecharClick={this.onFecharModalLista}
          onSalvarClick={this.onSalvarClick}
        />

        <VendaBalcaoCondicioanisForm
          visivel={modalCondicionaisVisible}
          listaRegistros={[]}
          onFecharClick={this.onFecharModalLista}
          onOKCondicionaisClick={this.onOKCondicionaisClick}
        />

        <ModalPadraoForm
          visivel={modalListaVisible}
          telaModal={telaModal}
          valorTotal={ven_vlr_total}
          onFecharClick={this.onFecharModalLista}
        />

        <CondicionalPrintModal
          visivel={formPrintCondVisivel}
          venc_idf={this.state.idfVenda}
          onCancelarPrintClick={this.onCancelarPrintClick}
        />

        <PedidoPrintA4Modal
          visivel={formPrintA4Visivel}
          ven_idf={this.state.idfVenda}
          tipoVenda="V"
          onCancelarPrintClick={this.onCancelarPrintClick}
        />

        <PedidoPrintCupomModal
          visivel={formPrintCupomVisivel}
          ven_idf={this.state.idfVenda}
          tipoVenda="V"
          onCancelarPrintClick={this.onCancelarPrintClick}
        />

        <CaixaLivre
          isOpen={this.state.modalOpen}
          onClose={() => this.setState({ modalOpen: false })}
        />

        <Col xs={24} sm={10} style={{ marginTop: 4, marginLeft: 10, marginRight: 10 }}>


          {/* ------------------------------ */}
          {/* PAINEL INCLUIR PRODUTOS        */}
          {/* ------------------------------ */}
          <div style={{ width: "100%", height: 245, padding: 2, marginBottom: 5, backgroundColor: Colors.background }}>
            <div style={{ width: "100%", height: 240, padding: 2, backgroundColor: Colors.fundoPage }}>
              <div style={{ width: "100%", height: "100%", backgroundColor: Colors.backgroundSecondary, padding: 10 }}>
                <Col xs={24} sm={24} style={{ marginTop: 0 }}>
                  <ProdutoFrame
                    label="Produto *"
                    id="mi_item"
                    value={mi_item}
                    width={"100%"}
                    onChange={this.onChangeProduto}
                  // descricaoPrimeiroItem="Selecione um Produto"
                  />
                </Col>

                <Col xs={24} sm={12} style={{ marginTop: -25, paddingRight: 10 }}>
                  <span style={{ fontSize: 13, paddingBottom: 5 }}>Qtde *</span>
                  <div style={{ marginTop: 4 }}>
                    <InputNumber
                      ref="Input"
                      id={mi_qtde}
                      value={mi_qtde}
                      onChange={this.onInputChangeQtde}
                      min={1}
                      max={999}
                      maxLength={6}
                      style={{ width: '100%' }}
                    />
                  </div>
                </Col>
                <Col xs={24} sm={12} style={{ marginTop: -25, }}>
                  <span style={{ fontSize: 13 }}>Preço *</span>
                  <InputForm
                    type="number"
                    id="mi_vlr_unit"
                    ref="mi_vlr_unit"
                    value={mi_vlr_unit}
                    onChange={this.onInputChangeVlrUnit}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ marginTop: -25, paddingRight: 10 }}>
                  <span style={{ fontSize: 13 }}>Desc (%)</span>
                  <InputForm
                    type="number"
                    id="mi_perc_desc"
                    ref="mi_perc_desc"
                    value={mi_perc_desc}
                    onChange={this.onInputChangePercDesc}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ marginTop: -25, paddingRight: 10 }}>
                  <span style={{ fontSize: 13 }}>Valor Desc</span>
                  <InputForm
                    type="number"
                    id="mi_vlr_desc"
                    ref="mi_vlr_desc"
                    value={mi_vlr_desc}
                    onChange={this.onInputChangeVlrDesc}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ marginTop: -25 }}>
                  <span style={{ fontSize: 13 }}>Total</span>
                  <InputForm
                    type="number"
                    id="mi_vlr_total"
                    ref="mi_vlr_total"
                    value={mi_vlr_total}
                    onChange={this.onChange}
                    disabled={true}
                  />
                </Col>
                <Col xs={24} sm={24} style={{ marginTop: -15 }}>
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={() => this.onFormIncluirProduto()}
                    className="botao-primary"
                    style={{ width: "100%" }}
                  >
                    Gravar Produto
                  </Button>
                </Col>
              </div>
            </div>
          </div>



          {/* ------------------------------ */}
          {/* PAINEL TOTAIS                  */}
          {/* ------------------------------ */}
          <div style={{ width: "100%", height: 75, padding: 2, marginBottom: 5, backgroundColor: Colors.background }}>
            <div style={{ width: "100%", height: 70, padding: 2, backgroundColor: Colors.fundoPage }}>
              <div style={{ width: "100%", height: "100%", backgroundColor: Colors.background, padding: 10 }}>
                <Col xs={24} sm={12} style={{}}>
                  <div style={{ textAlign: "center" }}>
                    <Row>
                      <span style={{ fontSize: 15, fontWeight: "bold" }}>Produtos *</span>
                    </Row>
                    <Row style={{}}>
                      <span style={{ fontSize: 20, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{ven_qtde_itens}</span>
                    </Row>
                  </div>
                </Col>
                <Col xs={24} sm={12} style={{}}>
                  <div style={{ textAlign: "center" }}>
                    <Row>
                      <span style={{ fontSize: 15, fontWeight: "bold" }}>Valor Total *</span>
                    </Row>
                    <Row style={{}}>
                      <span style={{ fontSize: 20, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(ven_vlr_total)}</span>
                    </Row>
                  </div>
                </Col>
              </div>
            </div>
          </div>





          {/* ------------------------------ */}
          {/* PAINEL PARA BOTÕES             */}
          {/* ------------------------------ */}
          <div style={{ width: "100%", height: windowHeight - 432, padding: 1, backgroundColor: Colors.background }}>
            <div style={{ width: "100%", height: "100%", padding: 1, marginBottom: 5, backgroundColor: Colors.fundoPage }}>
              <div style={{ width: "100%", height: "100%", backgroundColor: Colors.backgroundSecondary, padding: 5 }}>

                <Col xs={24} sm={12} style={{ padding: 5 }}>
                  <Tooltip title="Nova Venda" placement="topLeft">
                    <Button
                      type="primary"
                      icon="plus"
                      htmlType="button"
                      onClick={() => this.onNovoClick()}
                      style={{ width: "100%", height: 40 }}
                      className="botao-primary"
                    >
                      Novo
                    </Button>
                  </Tooltip>
                </Col>

                {listaProdutos && listaProdutos.length ? (
                  <Col xs={24} sm={12} style={{ padding: 5 }}>
                    <Tooltip title="Finalizar Venda" placement="topLeft">
                      <Button
                        type="primary"
                        icon="credit-card"
                        htmlType="button"
                        onClick={() => this.onReceberClick()}
                        style={{ width: "100%", height: 40 }}
                        className="botao-primary"
                      >
                        Finalizar Venda
                      </Button>
                    </Tooltip>
                  </Col>
                ) : null}

                {listaProdutos && listaProdutos.length ? (
                  <Col xs={24} sm={12} style={{ padding: 5 }}>
                    <Tooltip title="Opções de Pagamento" placement="topLeft">
                      <Button
                        type="ghost"
                        icon="pay-circle-o"
                        htmlType="button"
                        onClick={() => this.onPagtosClick()}
                        style={{ width: "100%", height: 40 }}
                      >
                        Opções de Pagtos
                      </Button>
                    </Tooltip>
                  </Col>
                ) : null}

                <Col xs={24} sm={12} style={{ padding: 5 }}>
                  <Tooltip title="Cadastro de Clientes" placement="topLeft">
                    <Button
                      type="ghost"
                      icon="usergroup-add"
                      htmlType="button"
                      onClick={() => this.onClientesClick()}
                      style={{ width: "100%", height: 40 }}
                    >
                      Clientes
                    </Button>
                  </Tooltip>
                </Col>

                <Col xs={24} sm={12} style={{ padding: 5 }}>
                  <Tooltip title="Ficha Financeira" placement="topLeft">
                    <Button
                      type="ghost"
                      icon="idcard"
                      htmlType="button"
                      onClick={() => this.onFichaFinancClick()}
                      style={{ width: "100%", height: 40 }}
                    >
                      Ficha Financeira
                    </Button>
                  </Tooltip>
                </Col>

                <Col xs={24} sm={12} style={{ padding: 5 }}>
                  <Tooltip title="Extrato do Caixa" placement="topLeft">
                    <Button
                      type="ghost"
                      icon="schedule"
                      htmlType="button"
                      onClick={() => this.onResumoCaixaClick()}
                      style={{ width: "100%", height: 40 }}
                    >
                      Extrato do Caixa
                    </Button>
                  </Tooltip>
                </Col>

                {((this.state.listaProdutos) && (this.state.listaProdutos.length === 0)) ? (
                  <Col xs={24} sm={12} style={{ padding: 5 }}>
                    <Tooltip title="Gerenciar Vendas" placement="topLeft">
                      <Button
                        type="ghost"
                        icon="file-text"
                        htmlType="button"
                        onClick={() => this.onListaVendasClick()}
                        style={{ width: "100%", height: 40 }}
                      >
                        Vendas
                      </Button>
                    </Tooltip>
                  </Col>
                ) : null}

                {((this.state.listaProdutos) && (this.state.listaProdutos.length === 0)) ? (
                  <Col xs={24} sm={12} style={{ padding: 5 }}>
                    <Tooltip title="Selecionar Condicionais" placement="topLeft">
                      <Button
                        type="ghost"
                        icon="exception"
                        htmlType="button"
                        onClick={() => this.onListaCondicionaisClick()}
                        style={{ width: "100%", height: 40 }}
                      >
                        Condicionais
                      </Button>
                    </Tooltip>
                  </Col>
                ) : null}

              </div>
            </div>
          </div>

        </Col>





        {/* ------------------------------ */}
        {/* PAINEL LISTA DOS PRODUTOS      */}
        {/* ------------------------------ */}
        <Col xs={24} sm={13} style={{ marginTop: 4 }}>
          <Card
            type="inner"
            bordered={false}
            style={{ paddingLeft: 0, marginLeft: 0, height: windowHeight - 155, backgroundColor: Colors.backgroundSecondary }}
          >
            <Row style={{ marginTop: -5, marginLeft: -10, marginRight: -10, marginBottom: -5 }}>
              <Table
                dataSource={listaProdutos}
                pagination={false}
                // scroll={{ y: 280 }}
                rowKey={(listaProdutos => listaProdutos.mi_item + '_' + listaProdutos.mi_item_tamanho + '_' + listaProdutos.mi_item_cor)}
              >
                <Column
                  key="prod_codigo"
                  dataIndex="prod_codigo"
                  title="Código"
                  width={60}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="prod_descricao"
                  dataIndex="prod_descricao"
                  title="Descrição"
                  width={200}
                  align="left"
                  className="listaCadastro"
                  render={this.renderDescrProduto}
                />
                <Column
                  key="mi_qtde"
                  dataIndex="mi_qtde"
                  title="Qtde"
                  render={this.renderValor}
                  width={60}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="mi_vlr_unit"
                  dataIndex="mi_vlr_unit"
                  title="Preço"
                  render={this.renderValor}
                  width={60}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="mi_vlr_total"
                  dataIndex="mi_vlr_total"
                  title="Total"
                  render={this.renderValor}
                  width={60}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="acoes"
                  title=""
                  render={this.renderAcoesProdutos}
                  width={80}
                  align="center"
                  className="listaCadastro"
                />
              </Table>
            </Row>
          </Card>
        </Col>

      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/VendaBalcaoPage.js